import { useTranslation } from "react-i18next";

const Footer = () => {
    const { t } = useTranslation();
    return (
        <>
            <div className="_portlet_pkebm_3 mt-6 p-6 text-center text-labels-medium uppercase text-content-tertiary pdf-section hide-mod">
                {t('Disclaimer_live')}
            </div>

            <div className="footer mb-5 mb-md-auto hide-mod">
                <div className="row my-4 small">
                    <div className="col-12 small text-center text-md-end mb-md-1 mb-2 fw-bold">
                        <a href="#" id="ftmo-cookie-settings" className=""> {t('CookieSettings')} </a>
                        &nbsp;
                        <a href="#" data-bs-toggle="modal" data-bs-target="#modal_privacy_policy">  {t('PrivacyPolicy')} </a>
                        &nbsp;
                        <a href="#" id="footer__link-terms-conditions"> {t('TermsConditions')} </a>
                    </div>

                    <div className="col-12 small">
                        <div className="col-12 small">
                            <p className="text-justify">
                                {t('Disclaimer')}<br />

                                {t('Disclaimer_text1')}<br />

                                {t('Disclaimer_text2')}<br />

                                {t('Disclaimer_text3')}<br />

                                {t('Disclaimer_text4')}<br />

                                {t('Disclaimer_text5')}<br />

                                {t('Disclaimer_text6')}<br />
                                {t('Disclaimer_text7')}<br />
                                {t('Disclaimer_text8')}<br />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Footer;